export const heading = 'See a better path forward.';
export const body =
  "There's a big difference between retiring and retiring comfortably. As you need to make key decisions, your advisor will help you understand what options are best for you.";
